import { motion } from "framer-motion";
import { Check } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];
const IMG = "https://images.pexels.com/photos/3873209/pexels-photo-3873209.jpeg?auto=compress&cs=tinysrgb&w=1000";

const ITEMS = [
    "Track your medications in one place",
    "Get instant allergy alerts",
    "Check drug interactions with AI",
    "FDA-verified medication data",
];

export default function HowItHelps() {
    return (
        <section className="px-6 py-14" data-testid="how-it-helps-section">
            <motion.div
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, ease: EASE }}
                className="rounded-3xl overflow-hidden"
            >
                <img
                    src={IMG}
                    alt="Medication capsules with a pill bottle and fresh oranges"
                    loading="lazy"
                    className="w-full aspect-[4/3] object-cover"
                    data-testid="how-it-helps-image"
                />
            </motion.div>

            <motion.p
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, ease: EASE }}
                className="mt-9 text-teal-dark font-bold text-[13px] tracking-[0.14em] uppercase"
            >
                How it helps
            </motion.p>
            <motion.h2
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: 0.08 }}
                className="mt-3 font-extrabold tracking-tight leading-[1.08] text-4xl text-ink"
            >
                A safer, calmer way to take your medication
            </motion.h2>

            <ul className="mt-8 space-y-5">
                {ITEMS.map((item, i) => (
                    <motion.li
                        key={item}
                        initial={{ opacity: 0, x: -18 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-50px" }}
                        transition={{ duration: 0.55, ease: EASE, delay: i * 0.08 }}
                        className="flex items-center gap-4"
                        data-testid={`how-it-helps-item-${i + 1}`}
                    >
                        <span className="w-9 h-9 rounded-full bg-teal grid place-items-center shrink-0">
                            <Check size={17} strokeWidth={3.5} className="text-white" />
                        </span>
                        <span className="font-semibold text-lg text-ink">{item}</span>
                    </motion.li>
                ))}
            </ul>
        </section>
    );
}
